export default "__VITE_ASSET__B3p7bOv5__"